<template>
    <v-flex class="banner_view__options__admin" v-if="getUserRoles && communityInfo">
        <v-select
            class="admin_select"
            v-model="selectedRole"
            item-text="role"
            data-qe-id="admin_view_select"
            :items="getUserRoles"
        >
        </v-select>
    </v-flex>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { storeGetters } from '../../store/storeGetters.constant';
import { storeMutation } from '../../store/storeMutations.constant';
import { userRoles as roles, routerNames } from '../appCommon.constants';
import { storeAction } from '../../store/storeActions.constant';

export default {
    name: 'AdminViewOptions',
    created() {
        if (this.$route.params && this.$route.params.routedFromChapterEvent) {
            this.getChapterUpcomingEvents();
            this.setCurrentCommunityView(this.userRoles.ADMIN);
            this.setDefaultAdminTool(this.userRoles.ADMIN);
        } else {
            this.setCurrentCommunityView(this.userRoles.MEMBER);
        }
    },
    data: () => {
        return {
            roles,
            routerNames,
        };
    },
    computed: {
        ...mapGetters({
            currentCommunityView: `${[storeGetters.currentCommunityView]}`,
            communityInfo: `chapter/${[storeGetters.communityInfo]}`,
            permissionsData: `auth/${storeGetters.permissionsData}`,
        }),
        isChapterPage() {
            return this.$route.name === this.routerNames.CHAPTER;
        },
        selectedRole: {
            get() {
                return this.currentCommunityView;
            },
            set(val) {
                if (this.currentCommunityView !== val) {
                    if (this.userRoles.BETA && val.toLowerCase() === this.userRoles.BETA.toLowerCase()) {
                        this.$router.push({
                            path: '/champs',
                            query: {
                                chapterName:
                                    this.communityInfo && this.communityInfo.name ? this.communityInfo.name : '',
                            },
                        });
                    } else {
                        this.getChapterUpcomingEvents();
                        this.setCurrentCommunityView(val);
                        this.setDefaultAdminTool(val);
                    }
                }
            },
        },
        userRoles() {
            const communityRoles = this.roles;
            if (
                this.permissionsData &&
                this.permissionsData.beta &&
                this.permissionsData.beta.AccessChampsInConnectApp
            ) {
                communityRoles.BETA = 'Beta View';
            }
            return communityRoles;
        },
        getUserRoles() {
            if (this.userRoles) {
                return Object.keys(this.userRoles).map((key, i) => {
                    return { id: i, role: this.userRoles[key] };
                });
            }
        },
    },
    methods: {
        ...mapActions({
            getUpcomingEventList: `chapter/${storeAction.getUpcomingEventList}`,
        }),
        ...mapMutations({
            setCurrentCommunityView: `${[storeMutation.setCurrentCommunityView]}`,
            toggleCATools: `chapter/${storeMutation.toggleCATools}`,
        }),
        getChapterUpcomingEvents() {
            if (this.isChapterPage && this.currentCommunityView === this.userRoles.ADMIN) {
                this.getUpcomingEventList();
            }
        },
        setDefaultAdminTool(view) {
            if (this.isChapterPage && view === this.userRoles.ADMIN) {
                this.toggleCATools(true);
            }
        },
    },
};
</script>
